import { $api } from '../generated/client';

export function useSearchProducts(shopId: string, q: string, options?: { enabled?: boolean }) {
  return $api.useQuery('get', '/shops/{shopId}/products', {
    params: {
      path: { shopId },
      query: q ? { q } : {},
    },
    enabled: options?.enabled ?? true,
  });
}
